import { requestInterval } from './utilities';

export default class LivePost {
  /**
   * HTMLElement of article
   *
   * @memberof LivePost
   */
  article;

  /**
   * HTMLElement of post content
   *
   * @memberof LivePost
   */
  content;

  /**
   * Date modified
   *
   * @memberof LivePost
   */
  modified;

  /**
   * Post Id
   *
   * @memberof LivePost
   */
  id;

  constructor() {
    this.article = document.querySelector('body.single-post article.is-live[data-post-id]');
    if (this.article) {
      this.id = this.article.dataset.postId;
      this.modified = this.article.dataset.postModified;
      this.content = this.article.querySelector('.entry-content');
      requestInterval(() => this.fetchPost().then(res => {
        if (this.modified !== res.modified) {
          this.content.innerHTML = res.content.rendered;
          this.modified = res.modified;
        }
      }), 10000);
    }
  }

  fetchPost() {
    return fetch(sw.rest_base + 'wp/v2/posts/' + this.id, {
      headers: {
        'X-WP-Nonce': sw.nonce
      }
    }).then(response => response.json());
  }
}
